const primary = "#E20613";
const secondary = "#35A8E0";
const third = "#FFD400";
const darkBlue = "#9dabc2";
const lightBlue = "#0954b4";

export { primary, secondary, third, darkBlue, lightBlue };
